(() => {
  const allowed = new Set(['price-descending', 'price-ascending', 'created-descending']);

  function sortedUrl(currentHref, value) {
    const url = new URL(currentHref);
    url.searchParams.set('sort_by', allowed.has(value) ? value : 'created-descending');
    url.searchParams.delete('page');
    return url.toString();
  }

  const select = document.querySelector('[data-lapidopia-sort]');
  const initialUrl = new URL(window.location.href);
  if (!allowed.has(initialUrl.searchParams.get('sort_by'))) {
    window.location.replace(sortedUrl(window.location.href, 'created-descending'));
  }

  select?.addEventListener('change', () => {
    window.location.assign(sortedUrl(window.location.href, select.value));
  });

  const categoryRail = document.querySelector('[data-lapidopia-category-rail]');
  const activeCategory = categoryRail?.querySelector('[data-lapidopia-category][aria-current="page"]');
  if (categoryRail && activeCategory) {
    categoryRail.scrollLeft = activeCategory.offsetLeft - (categoryRail.clientWidth - activeCategory.clientWidth) / 2;
  }

  window.LapidopiaCollectionSort = Object.freeze({ sortedUrl });
})();
